module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tree', {
    attrs: {
      "id": "1",
      "props": _vm.treeProps,
      "load": _vm.loadNode,
      "lazy": ""
    },
    on: {
      "node-contextmenu": _vm.rightClick
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('span', {
          staticClass: "custom-tree-node"
        }, [(node.level === 1) ? _c('span', {
          staticClass: "no-wrap"
        }, [_c('icon', {
          staticStyle: {
            "color": "777"
          },
          attrs: {
            "name": "atlas"
          }
        }), _vm._v("\n\t\t\t" + _vm._s(data.name) + "\n\t\t")], 1) : _vm._e(), _vm._v(" "), (node.level === 2) ? _c('span', [_c('icon', {
          staticStyle: {
            "color": "777"
          },
          attrs: {
            "name": "database"
          }
        }), _vm._v("\n\t\t\t" + _vm._s(data.name) + "\n\t\t")], 1) : _vm._e(), _vm._v(" "), (node.level === 3) ? _c('span', [(node.data.data.type === 'TABLE') ? [_c('icon', {
          staticStyle: {
            "color": "777"
          },
          attrs: {
            "name": "table"
          }
        })] : _vm._e(), _vm._v(" "), (node.data.data.type === 'VIEW') ? [_c('icon', {
          staticStyle: {
            "color": "777"
          },
          attrs: {
            "name": "eye"
          }
        })] : _vm._e(), _vm._v("\n\t\t\t" + _vm._s(data.name) + "\n\t\t")], 2) : _vm._e(), _vm._v(" "), (node.level === 4) ? _c('a-column-tree-item', {
          attrs: {
            "column": data.data
          }
        }) : _vm._e()], 1)
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6445f2f0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalog/CatalogViewer.vue
// module id = 2143
// module chunks = 1